/* eslint-disable quote-props */
export default {
  cn: {
    Common: {
      '制空権シミュレータ': '制空权模拟器',
      'サイト設定': '网站设置',
      'マスターデータ読込中': '正在加载主数据',
      'OK': '确定',
      '実行': '执行',
      '戻る': '返回',
      'キャンセル': '取消',
      'リセット': '重置',
      '出力': '输出',
      '作成': '创建',
      '更新': '更新',
      '適用': '应用',
      '展開': '展开',
      '閉じる': '关闭',
      '初期値': '初始值',
      '最大値': '最大值',
      '既定値': '默认值',
      '削除': '删除',
      '編集': '编辑',
      '保存': '保存',
      '別名保存': '另存为',
      '共有': '分享',
      '編成共有': '编组分享',
      '元に戻す': '撤销',
      'やり直す': '重做',
      '編成アップロード': '上传编组',
      'コピーされました。': '已复制。',
      'コードをコピー': '复制代码',
      '取込': '导入',
      '検索': '搜索',
      '件': '件',
      'さらに読み込む': '加载更多',
      '制空値': '制空值',
      '制空': '制空',
      '基地制空': '基地制空',
      '敵制空値': '敌方制空值',
      '防空制空': '防空制空',
      'x機': '{number}架',
      '装備名称': '装备名称',
      '艦娘名': '舰娘名称',
      '装備名': '装备名称',
      '敵艦名': '敌方舰船名称',
      '図鑑ID': '图鉴ID',
      '耐久': '耐久',
      '火力': '火力',
      '砲戦火力': '炮战火力',
      '夜戦火力': '夜战火力',
      '支援火力': '支援火力',
      '雷撃火力': '雷击火力',
      '雷装': '雷装',
      '爆装': '爆装',
      '装甲': '装甲',
      '対空': '对空',
      '出撃対空': '出击对空',
      '防空対空': '防空对空',
      '索敵': '索敌',
      '回避': '回避',
      '命中': '命中',
      '支援命中': '支援命中',
      '対潜': '对潜',
      '対爆': '对爆',
      '迎撃': '迎击',
      '射程': '射程',
      '搭載数': '搭载数',
      '極長+': '极长+',
      '極長': '极长',
      '極+': '极+',
      '極': '极',
      '超長+': '超长+',
      '超長': '超长',
      '長': '长',
      '中': '中',
      '短': '短',
      '半径': '半径',
      'tp': 'TP',
      'TP': 'TP',
      'コスト': '消耗',
      '配置コスト': '配置消耗',
      '射撃回避': '射击回避',
      '回避性能': {
        '超': '超',
        '強': '强',
        '中': '中',
        '弱': '弱',
        '任意': '任意',
        'なし': '',
        '': '',
      },
      '装甲減少': '装甲补正',
      '命中項': '命中项',
      '回避項': '回避项',
      'CI項': 'CI项',
      '熟練度': '熟练度',
      '改修': '改修',
      '改修値': '改修值',
      '加重対空': '加重对空',
      '艦隊防空': '舰队防空',
      '艦隊防空値': '舰队防空值',
      'Lv': '等级',
      '改造Lv': '改造等级',
      '運': '运',
      '速力': '速度',
      '総搭載数': '总搭载数',
      '装備命中': '装备命中',
      '確保': '确保',
      '優勢': '优势',
      '拮抗': '均势',
      '劣勢': '劣势',
      '喪失': '丧失',
      '不発': '未发动',
      '制空権確保': '制空权确保',
      '航空優勢': '航空优势',
      '航空拮抗': '航空均势',
      '航空劣勢': '航空劣势',
      '制空権喪失': '制空权丧失',
      '陣形': '阵型',
      '単縦陣': '单纵阵',
      '複縦陣': '复纵阵',
      '輪形陣': '轮形阵',
      '梯形陣': '梯形阵',
      '単横陣': '单横阵',
      '警戒陣': '警戒阵',
      '第一警戒': '第一警戒',
      '第二警戒': '第二警戒',
      '第三警戒': '第三警戒',
      '第四警戒': '第四警戒',
      '通常': '通常',
      '連合': '联合',
      '空襲': '空袭',
      '夜戦': '夜战',
      '重爆': '重爆',
      '航空戦': '航空战',
      '超重爆': '超重爆',
      '対潜空襲': '对潜空袭',
      '支援': '支援',
      '合計': '合计',
      '平均': '平均',
      '順序入替': '顺序调整',
      '入替完了': '调整完成',
      '一括変更': '批量更改',
      '一括設定': '批量设置',
      'スクリーンショットを保存': '保存截图',
      '最小化': '最小化',
      '探したけど見つからなかったよ': '搜索但未找到',
      'もしかして': '可能是:',
      '検索条件': '搜索条件',
      '既に配備されています。': '已经部署。',
      '配備を押せば無視して配備できます。': '点击部署可以忽略并继续部署。',
      '配備': '部署',
      '比較': '比较',
      '適用対象': '应用对象',
      '選択されている航空隊に対し、下記の設定を適用します。': '将对选中的航空队应用以下设置。',
      '選択されている艦隊の全艦娘に対し、下記の設定を適用します。': '将对选中舰队的全体舰娘应用以下设置。',
      '戦闘機のみ最大': '仅战斗机最大',
      '艦載機搭載数': '舰载机搭载数',
      '本当に削除しますか？': '确定要删除吗？',
      '装備特効表示': '装备特效显示',
      'なし': '无',
      '鎮守府秋刀魚祭り': '镇守府秋刀鱼祭',
      'ソート': '排序',
      '読み': 'あいうえお',
      '昇順': '升序',
      '降順': '降序',
      '燃料': '燃料',
      '弾薬': '弹药',
      '燃料+弾薬': '燃料+弹药',
      '運改修': '运改修',
      '遠征': '远征',
      '艦隊に艦載機が含まれています。遠征における艦載機の性能に対する補正の計算式が不明なため、遠征のステータス調整に利用する際は十分注意してください。': '舰队中包含舰载机。由于远征中舰载机性能补正的计算公式不明，在调整远征状态时请谨慎使用。',
      '遠征ステータスチェッカー': '远征状态检查器',
      '旗艦Lv': '旗舰等级',
      '合計Lv': '总等级',
      '絞り込み': '筛选',
      'その他': '其他',
      '最終更新日時': '最后更新时间',
      '外部データ': '外部数据',
      '表示ステータス': '显示状态',
      '基本装備性能': '基本装备性能',
      '改修ボーナス': '改修效果',
      '実性能': '实际性能',
      '航空隊ステータス': '航空队状态',
    },
    Statuses: {
      'actualFire': '火力',
      'dayBattleFirePower': '炮战火力',
      'actualTorpedo': '雷装',
      'nightBattleFirePower': '夜战火力',
      'actualBomber': '爆装',
      'antiAir': '对空',
      'actualAntiAir': '出击对空',
      'actualDefenseAntiAir': '防空对空',
      'actualArmor': '装甲',
      'actualAsw': '对潜',
      'actualAvoid': '回避',
      'actualScout': '索敌',
      'actualAccuracy': '命中',
      'antiBomber': '对爆',
      'antiAirWeight': '加重对空',
      'antiAirBonus': '舰队防空',
      'radius': '半径',
      'cost': '消耗',
      'tp': 'TP',
      'avoidId': '射击回避',
      'actualRange': '射程',
    },
    Difficulty: {
      '難易度': '难度',
      '甲': '甲',
      '乙': '乙',
      '丙': '丙',
      '丁': '丁',
    },
    Setting: {
      '言語': '语言',
      '艦娘や装備名は翻訳しない': '不翻译舰娘和装备名称',
      'サイトカラーテーマ': '网站颜色主题',
      '通常': '通常',
      '空色': '天蓝色',
      '桜色': '樱色',
      '翠色': '翠色',
      '暗色': '暗色',
      '深海': '深海',
      '装備表示UI調整': '装备显示UI调整',
      '枠線': '边框',
      '太枠': '粗边框',
      '角丸': '圆角',
      'sample': '示例',
      '未保存の編成タブを閉じる際の挙動': '关闭未保存编组标签页时的行为',
      '確認ダイアログを表示する': '显示确认对话框',
      '編成データのオートセーブ': '编组数据自动保存',
      'オートセーブを有効にする': '启用自动保存',
      '画像保存形式': '图片保存格式',
      'マウスホバー時の詳細情報表示': '鼠标悬停时显示详细信息',
      '無効(装備)': '禁用(装备)',
      '無効(艦娘)': '禁用(舰娘)',
      '表示までのディレイ': '显示延迟',
      '制空計算時のシミュレーション回数': '制空计算时的模拟次数',
      '数値が大きいほど計算の精度が上がりますが、': '数值越大计算精度越高，但',
      '計算時のパフォーマンスが低下します。': '会降低计算性能。',
      '回': '次',
      '装備選択時のデフォルト熟練度': '选择装备时的默认熟练度',
      '一括設定': '批量设置',
      'デッキビルダー形式データ読込設定': 'Deck Builder格式数据读取设置',
      '全滅率インジケーター表示': '全灭率指示器显示',
      '図形で区別': '用图形区分',
      '常に全艦隊データを読み込む': '始终加载所有舰队数据',
      '編成データのバックアップ': '编组数据备份',
      '復元': '恢复',
      '保存した編成データのバックアップファイルを作成します': '创建已保存编组数据的备份文件',
      '復元するバックアップファイルを選択': '选择要恢复的备份文件',
      '復元するデータ選択': '选择要恢复的数据',
      '編成データ': '编组数据',
      '在籍艦娘データ': '在籍舰娘数据',
      '所持装備データ': '持有装备数据',
      '艦隊URL出力履歴': '舰队URL输出历史',
      '装備変更時の比較画面の表示': '装备变更时显示比较画面',
    },
    Home: {
      '制空権シミュレータ': '制空权模拟器',
      'デッキビルダー形式データ': 'Deck Builder格式数据',
      'URL情報より復元された艦娘在籍情報、装備所持情報が適用されています。': '已应用从URL信息恢复的舰娘在籍信息和装备持有信息。',
      '自分の登録情報に戻す場合は次のボタンを押下してください。': '要返回您的注册信息，请点击以下按钮。',
      '終了': '结束',
      '作成した日': '当前应用的舰队数据创建于{date}。',
      'メインメニュー': '主菜单',
      '本サイトの主要機能です。': '这是本网站的主要功能。',
      '基地航空隊や艦隊、敵艦隊を編成することで、道中を含めた全ての戦闘の制空状態や艦載機の損耗、全滅率などのシミュレーションが可能です。': '通过编组基地航空队、舰队和敌方舰队，可以模拟包括途中在内的所有战斗的制空状态、舰载机损耗和全灭率等。',
      '艦娘 / 装備管理': '舰娘/装备管理',
      'サブの機能です。': '这是子功能。',
      '自分のゲーム内の艦娘、装備情報を登録すると、シミュレータ内で選択できる艦娘や装備に反映され、あの装備持ってた…？と悩む心配がなくなります。': '注册您在游戏中的舰娘和装备信息后，这些信息会反映在模拟器中可选择的舰娘和装备中，不用担心"那个装备我有吗？"这样的问题。',
      'みんなの編成': '大家的编组',
      '他の人がアップロードした編成データを閲覧できます。': '可以查看其他人上传的编组数据。',
      'おまけ': '额外功能',
      'おまけのページです': '这是额外功能页面。',
      'データ引き継ぎ': '数据转移',
      '本サイトで作成した編成データなどを他の端末やブラウザに引き継げます': '可以将在本网站创建的编组数据转移到其他设备或浏览器。',
      'バックアップファイルを作成する': '创建备份文件',
      'そろそろバックアップしませんか？': '差不多该备份一下了，要现在备份吗？',
      '前回の編成データのバックアップからわりと時間が経っています。': '距离上次备份编组数据已经过了相当一段时间。',
      'なんらかの影響で編成データが消えた時のために、バックアップファイルを作成することをオススメします。': '为防止因浏览器或设备异常等原因导致数据丢失，建议创建一个备份文件。',
      'この通知は、最後のバックアップからだいたい1ヵ月くらいに1度表示されます。今回はスキップした場合も、再度1か月後くらいに通知されます。': '此提示会在距离上次备份大约1个月后显示一次。即使这次选择跳过，也会在大约1个月后再次提醒。',
      '今すぐバックアップ': '立即备份',
      '今回はスキップ': '这次跳过',
      '作成されたバックアップファイルを、引き継ぎ先のPCや端末に移動させる': '将创建的备份文件移动到目标PC或设备。',
      '引き継ぎ先で制空権シミュレータv2を開き、サイト設定を開く': '在目标PC或设备上打开制空权模拟器v2，打开网站设置。',
      '手順2で移動させてきたバックアップファイルを選択すれば引き継ぎは完了です': '选择步骤2中移动的备份文件即可完成转移。',
      '旧制空権シミュレータ': '旧制空权模拟器',
      'で作成していた編成データや、登録されていた装備、艦娘情報を引き継ぎます。': '转移在旧版本中创建的编组数据、已注册的装备和舰娘信息。',
      'データ引継ぎ(編成)': '数据转移(编组)',
      'データ引継ぎ(装備/艦娘)': '数据转移(装备/舰娘)',
      '引き継ぎ対象のデータを格納するフォルダーを作成します。': '创建存储转移目标数据的文件夹。',
      'フォルダー名を指定し、実行を押すと引き継ぎを開始します。': '指定文件夹名称并点击执行即可开始转移。',
      '既に本サイトで装備 / 艦娘情報が登録されているようです。': '似乎已经在本网站注册了装备/舰娘信息。',
      '引き継ぎを行うとこれらのデータは上書きされます。': '进行转移将覆盖这些数据。',
      '本当に引き継ぎを行いますか？': '确定要进行转移吗？',
      'サイト連携': '网站联动',
      'デッキビルダー形式をURLに ?predeck=で埋め込めば編成を読み込めます。': '将Deck Builder格式嵌入URL的?predeck=参数中即可加载编组。',
      'URLが長すぎて上記の方法でエラーが出る場合は、URL fragmentsを利用した受け渡しも可能です。': '如果URL太长导致上述方法出错，也可以使用URL fragments进行传递。',
      'また、URL fragmentsを利用した形式では艦隊分析コード(艦娘、装備)形式の読み込みも同時に行うことができます。': '此外，使用URL fragments格式时也可以同时加载舰队分析代码(舰娘、装备)格式。',
      'ご支援': '支持我们',
      '本サイトは無料ですが、それでもご支援いただけるという方向けに支援の手段を用意しました。': '虽然本网站是免费的，但我们为愿意支持的用户准备了支持方式。',
      'いつも本当にありがとうございます。': '一直以来非常感谢。',
      '匿名でも利用可能な投げ銭サービスです。': '可以使用匿名投币服务。',
      'Amazon ほしい物リスト': 'Amazon愿望清单',
      '物資やギフト券といった形であればこちら。': '如果想以物资或礼品卡形式支持，请点击这里。',
      '著作権法第32条に基づき画像を引用し、著作権は権利者様へ帰属します。権利者様側からの画像等の削除の依頼や警告には速やかに対処いたします。': '根据著作权法第32条引用图片，著作权归权利人所有。我们会及时处理权利人提出的图片删除请求或警告。',
      'また、本サイトの情報、計算結果によって受けた利益・損害その他あらゆる事象については一切の責任を負いません。': '此外，对于因本网站信息、计算结果而产生的利益、损害或其他任何情况，我们概不负责。',
      '編成データ名': '编组数据名称',
      '補足情報': '补充信息',
      '更新しました。': '已更新。',
      '艦隊選択': '舰队选择',
      '常に全艦隊取り込む': '始终导入所有舰队',
      '取り込む艦隊を選択し、取り込みボタンを押してください。': '选择要导入的舰队，然后点击导入按钮。',
      'チェックすると、次回以降、常に全ての艦隊を取り込むようになります。': '勾选后，从下次开始将始终导入所有舰队。',
      'この設定は、設定からいつでも変更できます。': '此设置可以随时在设置中更改。',
      '本ブラウザではデータ保存機能が利用できません。': '此浏览器不支持数据保存功能。',
      'お使いのブラウザはIndexedDB非対応のようです。': '您的浏览器似乎不支持IndexedDB。',
      '編成、設定、艦娘/装備を含む全データは本サイトを閉じた時点で削除されます。': '包括编组、设置、舰娘/装备在内的所有数据将在关闭本网站时删除。',
      '別のブラウザのご利用をお勧めします。': '建议使用其他浏览器。',
      '旧編成データが見つかりませんでした。': '未找到旧编组数据。',
      '所持装備 / 艦娘データが見つかりませんでした。': '未找到持有装备/舰娘数据。',
      'データを読み込みましたが、引き継ぎ可能な編成データがありませんでした。': '已加载数据，但没有可转移的编组数据。',
      '所持装備 / 艦娘データの引き継ぎが完了しました。': '持有装备/舰娘数据转移完成。',
      '編成データの引き継ぎが完了しました。': '编组数据转移完成。',
      'データ引継ぎに失敗しました。': '数据转移失败。',
      '新しいフォルダーを作成しました。': '已创建新文件夹。',
      '新しい編成を作成しました。': '已创建新编组。',
      '削除が完了しました。': '删除完成。',
      '編成の読み込みが完了しました。': '编组加载完成。',
      'デッキビルダー形式編成データを読み込みました。': '已加载Deck Builder格式编组数据。',
      '在籍艦娘データの更新が完了しました。': '在籍舰娘数据更新完成。',
      '所持装備データの更新が完了しました。': '持有装备数据更新完成。',
      'データの読み込みに失敗しました。正しいデータではない可能性があります。': '数据加载失败。可能不是正确的数据。',
      '保存しました。': '已保存。',
      '保存に失敗しました。': '保存失败。',
      '所持情報の読み取りに失敗しました。': '持有信息读取失败。',
      '閲覧モードを終了しました。': '已退出浏览模式。',
      '読み込み失敗 -バックアップデータが壊れてるか、なんか違うファイルです。': '加载失败 -备份数据可能损坏或不是正确的文件。',
      'バックアップデータを復元しました。': '已恢复备份数据。',
      '入力欄を入れ替えました。': '已交换输入栏。',
      '100 ～ 100000で指定してください。': '请在100到100,000之间指定。',
      '編成名 / 補足情報': '编组名称/补充信息',
      'トップ画面へ戻る': '返回顶部画面',
      '艦娘、装備情報が登録されていません。': '未注册舰娘、装备信息。',
      '共有URLを生成しました。': '已生成分享URL。',
      '共有URLの生成に失敗しました。': '分享URL生成失败。',
      '出力履歴を削除しました。': '已删除输出历史。',
      '計算が完了しました。': '计算完成。(+100,000次)',
      'ドラッグ & ドロップで入力欄を好きな順に並べ替え、入替完了を押してください。': '通过拖放调整输入栏顺序，然后点击调整完成。',
      'アップロードが完了しました。': '上传完成。',
      'アップロードに失敗しました。': '上传失败。',
      '翻訳がまだ不完全な状態です。よろしければ助けていただけると幸いです。': '翻译尚未完成。如果您愿意帮忙，我们将不胜感激。',
      'お題箱': '问题箱',
      'コピーされました。': '已复制。',
      '更新が完了しました。': '更新完成。',
      '編成を展開しました。': '已展开编组。',
      'URL fragmentsよりデータを読み込みました。': '已从URL fragments加载数据。',
      '更新履歴': '更新历史',
      '雑です。': '很粗糙。',
    },
    SaveData: {
      '新しい編成を作成': '创建新编组',
      '新しいフォルダーを作成': '创建新文件夹',
      'フォルダーを全て開く': '展开所有文件夹',
      'フォルダーを全て閉じる': '折叠所有文件夹',
      'サイドバー固定': '固定侧边栏',
      'サイドバー固定解除': '解除侧边栏固定',
      '複製して開く': '复制并打开',
      '情報を変更': '更改信息',
      '名前順でソート': '按名称排序',
      'このフォルダー内の全データ、フォルダーを名前順にソートします。': '将此文件夹中的所有数据和文件夹按名称排序。',
      '本当にこのフォルダーを削除しますか？': '确定要删除此文件夹吗？',
      '外部データを全て削除します。よろしいですか？': '将删除所有外部数据。确定吗？',
      '本当にこのデータを削除しますか？': '确定要删除此数据吗？',
      'フォルダー内の全データ、フォルダーが削除されます。': '文件夹中的所有数据和文件夹将被删除。',
      'フォルダー名': '文件夹名称',
      '編成データ名': '编组数据名称',
      '補足情報': '补充信息',
      '保存されたデータ': '已保存的数据',
      '共有URLを生成': '生成分享URL',
      'Twitterで共有': '在Twitter上分享',
      '作戦室で開く': '在作战室中打开',
      '羅針盤シミュで開く': '在罗盘模拟器中打开',
      'デッキビルダーで開く': '在Deck Builder中打开',
      'URLの発行に失敗しました。': 'URL生成失败。',
      '未保存の変更内容がありますが、このまま編成タブを閉じますか？': '有未保存的更改，确定要关闭编组标签页吗？',
      '戻って保存するには、サイト上部の保存ボタンを押してください。': '要返回保存，请点击网站顶部的保存按钮。',
      '変更内容を破棄してタブを閉じる場合は、このままOKボタンを押してください。': '要放弃更改并关闭标签页，请直接点击确定按钮。',
      '次回以降表示しない': '下次不再显示',
      '新規データ': '新数据',
      '新しいフォルダー': '新文件夹',
      '引き継ぎデータ': '转移数据',
      '投稿者': '投稿者',
      '『トップページ > みんなの編成』ページにて公開される編成をアップロードできます。': '可以在"首页 > 大家的编组"页面上传要公开的编组。',
      '編成のアップロードを行います。よろしいですか？': '确定要上传编组吗？',
      '海域、難易度の指定が正しいか、アップロード前に今一度確認してください。': '上传前请再次确认海域和难度的指定是否正确。',
      '原則、アップロードした編成をあとから編集・削除することはできません。': '原则上，上传后的编组无法进行编辑或删除。',
      'どうしても削除したい場合、編成名や投稿者、出撃海域、更新日時や編成の特徴など、削除対象が特定できる情報を添えてご連絡ください。': '如果一定要删除，请提供编组名称、投稿者、出击海域、更新时间和编组特征等能够识别删除对象的信息。',
    },
    Airbase: {
      '基地航空隊': '基地航空队',
      '全航空隊': '全航空队',
      '第x基地航空隊': '第{number}基地航空队',
      '第x航空隊': '第{number}航空队',
      '防空計算モード': '防空计算模式',
      '基地派遣先設定': '基地派遣目标设置',
      '出撃': '出击',
      '防空': '防空',
      '待機': '待机',
      '防空時制空値': '防空时制空值',
      '対重爆制空値': '对重爆制空值',
      '対超重爆制空値': '对超重爆制空值',
      '対重爆補正': '对重爆补正',
      '対超重爆補正': '对超重爆补正',
      '補正A': '补正A',
      '補正B': '补正B',
      '補正C': '补正C',
      '補正D1': '补正D1',
      '補正D2': '补正D2',
      '{target}基地航空隊の半径が不足している可能性があります。': '{target}基地航空队的半径可能不足。',
      '{target}基地航空隊の半径が不足しています。': '{target}基地航空队的半径不足。',
      '第x波': '第{number}波',
      '搭載数を最大に戻す': '恢复最大搭载数',
      '基地空襲被害を発生させる': '产生基地空袭伤害',
      '第1スロットから順に搭載数を4機減らします。': '从第1个槽位开始依次减少4架搭载数。',
      '全基地航空隊リセット': '重置所有基地航空队',
      '基地航空隊派遣先設定': '基地航空队派遣目标设置',
      '基地航空隊詳細': '基地航空队详情',
      '基地空襲が発生します。基地空襲による被害を考慮してください。': '将发生基地空袭。请考虑基地空袭造成的伤害。',
      '基地クリップボード': '基地剪贴板',
      '基地全てクリップボードへ追加': '将所有基地添加到剪贴板',
    },
    Fleet: {
      '自艦隊': '我方舰队',
      '全艦隊': '全舰队',
      '12隻表示': '显示12艘',
      '第x艦隊': '第{number}舰队',
      '艦隊追加': '添加舰队',
      '艦隊削除': '删除舰队',
      '第x艦隊以降のデータは本サイト内でのみ有効で、外部サイトへの出力の対象になりません。': '第5舰队及以后的数据仅在本网站内有效，不会成为外部网站输出的对象。',
      '画像出力': '图片输出',
      '司令部Lv': '司令部等级',
      '連合艦隊': '联合舰队',
      '主力艦隊': '主力舰队',
      '随伴艦隊': '随伴舰队',
      '艦隊形式': '舰队形式',
      '通常艦隊': '通常舰队',
      '空母機動部隊': '航母机动部队',
      '水上打撃部隊': '水上打击部队',
      '輸送護衛部隊': '运输护卫部队',
      '艦娘選択': '选择舰娘',
      '未装備': '未装备',
      '補強増設未開放': '未开放补强增设',
      '艦娘': '舰娘',
      '装備': '装备',
      '装備ボーナス': '装备加成',
      '触接': '触接',
      '夜偵': '夜侦',
      '艦隊詳細': '舰队详情',
      '艦隊情報': '舰队信息',
      '艦隊ステータス': '舰队状态',
      '対空砲火': '对空炮火',
      '航空戦火力': '航空战火力',
      '夜間航空攻撃': '夜间航空攻击',
      '対潜支援火力': '对潜支援火力',
      '航空支援火力': '航空支援火力',
      '撃墜': '击坠',
      '噴進': '喷进',
      '先制対潜': '先制对潜',
      '対潜先制爆雷攻撃': '对潜先制爆雷攻击',
      '可': '可',
      '不可': '不可',
      '不足対潜値': '不足对潜值',
      '必要艦娘Lv': '所需舰娘等级',
      'x列': '{number}列',
      '特殊攻撃': '特殊攻击',
      '一撃大破': '一击大破',
      '一撃中破': '一击中破',
      '主主CI': '主主CI',
      '連撃': '连击',
      '主徹CI': '主彻CI',
      '主電CI': '主电CI',
      '主副CI': '主副CI',
      'FBA': 'FBA',
      'BBA': 'BBA',
      'BA': 'BA',
      'jFjBjB': 'jFjBjB',
      'jFjB': 'jFjB',
      'jFBA': 'jFBA',
      '夜間特殊攻撃': '夜间特殊攻击',
      '通常': '通常',
      '主主主CI': '主主主CI',
      '主主副CI': '主主副CI',
      '魚雷CI': '鱼雷CI',
      '砲雷CI': '炮雷CI',
      '主魚電CI': '主鱼电CI',
      '魚見電CI': '鱼见电CI',
      '魚水魚CI': '鱼水鱼CI',
      '魚ド水CI': '鱼ド水CI',
      '潜電魚CI': '潜电鱼CI',
      '潜魚雷CI': '鱼雷CI(潜)',
      '夜襲CIA': '夜袭CI (x1.25)',
      '夜襲CIB': '夜袭CI (x1.20)',
      '光電管彗星CI': '光电管彗星CI',
      '夜爆CI': '夜爆CI (x1.20)',
      '夜襲CIC': '夜袭CI (x1.18)',
      '合計': '合计',
      '搭載数': '搭载数',
      '最終戦闘までの撃墜数に応じて、搭載数を自動設定します。': '根据到最终战斗为止的击坠数自动设置搭载数。',
      '満タン': '满载',
      '最小': '最小',
      '平均': '平均',
      '最大': '最大',
      '戦闘機スロットを最適化': '优化战斗机槽位',
      '全艦隊リセット': '重置所有舰队',
      '艦隊リセット': '重置舰队',
      '艦娘入力欄を増やす': '增加舰娘输入栏',
      '艦娘入力欄を減らす': '减少舰娘输入栏',
      'ステータス': '状态',
      '改造状態': '改造状态',
      '未改造': '未改造',
      '中間改造': '中间改造',
      '最終改造': '最终改造',
      '装備搭載可否': '装备搭载可否',
      '戦闘機': '战斗机',
      '甲標的': '甲标的',
      '大型探照灯': '大型探照灯',
      '護衛空母': '护卫航母',
      '装備スロット数': '装备槽位数',
      '2スロ以上': '2槽位以上',
      '3スロ以上': '3槽位以上',
      '4スロ以上': '4槽位以上',
      '5スロ以上': '5槽位以上',
      '最速': '最快',
      '高速+': '高速+',
      '高速': '高速',
      '低速': '低速',
      '低速統一': '低速统一',
      '艦隊': '舰队',
      '札あり': '有标记',
      '補強増設': '补强增设',
      '開放': '开放',
      '13号電探系': '13号电探',
      '22号電探系': '22号电探',
      '電探マスト': '电探桅杆',
      'その他電探': '其他电探',
      '在籍艦娘反映': '反映在籍舰娘',
      '自動先制対潜': '自动先制对潜',
      'お気に入り': '收藏',
      'お気に入り編集': '编辑收藏',
      'ケッコン艦': '婚舰',
      '全解除': '解除所有收藏舰娘',
      '搭載': '搭载',
      'コンバート改造': '转换改造',
      '艦娘クリップボード': '舰娘剪贴板',
      '艦隊クリップボード': '舰队剪贴板',
      '現在の艦隊': '当前舰队',
      'デッキビルダー読込': 'Deck Builder读取',
      '艦隊クリップボードにデッキビルダー形式の艦隊データを直接追加することができます。': '可以直接将Deck Builder格式的舰队数据添加到舰队剪贴板。',
      '装備プリセット展開': '装备预设展开',
      '計算対象から省く': '从计算对象中排除',
      '装備一括解除': '批量解除装备',
      '対空CI': '对空CI',
      '攻撃機搭載数': '攻击机搭载数',
      '対空射撃回避': '对空射击回避',
      '加重対空補正': '加重对空补正',
      '艦隊防空補正': '舰队防空补正',
      '割合撃墜': '比例击坠',
      '固定撃墜': '固定击坠',
      '最低保証': '最低保证',
      '両成功': '双重成功',
      '空襲マス': '空袭格',
      '敵側式': '敌方公式',
      'クリップボード': '剪贴板',
      'クリックで展開': '点击展开',
      'クリップボードへ追加': '添加到剪贴板',
      '艦隊に艦娘が設定されていません。': '舰队中未设置舰娘。',
      '索敵値が不足している可能性があります。': '索敌值可能不足。所需索敌值: {LoS}, 分岐点系数: {num}',
      '航空偵察': '航空侦察得分: {score}、所需: {required}、大成功: {success}',
      'この艦隊に属する全ての艦娘が対象です。': '适用于属于此舰队的全体舰娘。',
      '既に札がついている艦娘も上書きする': '覆盖已有标记的舰娘',
      '現在の登録情報に置き換え': '替换当前注册信息',
      '存在しない艦娘、装備の置換方法を選択してください。': '请选择不存在的舰娘、装备的替换方法。',
      'この機能を使う場合は、まず艦隊反映を行ってください。': '使用此功能时，请先进行舰队反映。',
      '配備されているすべての艦娘と装備を、': '将部署的所有舰娘和装备，',
      'で登録されている在籍、所持情報をもとに、なるべくいい感じになるように置き換えます。': '根据注册的在籍、持有信息进行尽可能合适的替换。',
      'はずす': '移除',
      'そのままにする': '保持原样 (不存在时将显示为红色)',
      '必要': '需要{name}{x}艘。',
      '以下': '{name}最多{x}艘。',
      '編成不可': '无法编组{name}。',
      '旗艦': '请将{name}设为旗舰。',
      '旗艦不可': '无法将{name}设为旗舰。',
      '高速化': '请提高{name}的速度。',
      '潜水艦隊攻撃配置警告': '潜水舰队攻击需要2号位和3号位为潜水舰。',
      '潜水艦隊攻撃4隻配置警告': '潜水舰队攻击(4舰)需要2号位、3号位和4号位为潜水舰。',
      '戦艦特殊砲撃水上艦不足警告': '战舰特殊炮击需要同一舰队至少编入6艘水上舰。',
      '装備置き場生成': '生成装备放置区',
      '装備を自由に置くスペースです。': '这是可以自由放置装备的空间。',
      '一括編成': '批量编组',
      '選択済': '已选择',
    },
    Enemies: {
      '海域': '海域',
      '海域名': '海域名称',
      '敵艦隊': '敌方舰队',
      '海域から一括入力': '从海域批量输入',
      '戦闘回数が変更されている可能性があります。派遣先を確認してください。': '战斗次数可能已更改。请确认派遣目标。',
      '戦闘回数': '战斗次数',
      '航路': '航路',
      'x戦目': '第{number}战',
      '搭載数が未確定の敵艦が含まれています。': '包含搭载数未确定的敌方舰船。',
      '表示制空値は目安のもので、正確な制空値ではありません。': '显示的制空值仅供参考，不是准确的制空值。',
      '海域選択': '选择海域',
      '敵艦選択': '选择敌方舰船',
      'セル': '格',
      '戦闘形式': '战斗形式',
      '陣形': '阵型',
      '詳細': '详情',
      '展開したい海域、セル、敵編成を選択してください。': '请选择要展开的海域、格和敌方编组。',
      '選択したセル': '已选择的格',
      '前哨': '前哨',
      '最終': '最终',
      'クリア後': '通关后',
      '地上施設': '地上设施',
      '変更する': '更改',
      'はずす': '移除',
      '詳細設定': '详细设置',
      '基地航空隊フェーズで撃沈しない': '基地航空队阶段不击沉',
      '基地航空隊フェーズで撃沈する': '基地航空队阶段击沉',
      '耐久装甲表示': '显示耐久装甲',
      '本当に戦闘は1戦だけですか？意図せずこのエラーが出ている場合は、経由する道中の敵編成を全て入力してください。': '真的只有1场战斗吗？如果无意中出现此错误，请输入所有途经的敌方编组。',
    },
    Result: {
      '計算結果': '计算结果',
      '計算結果が実際の制空状態と異なる可能性があります。': '计算结果可能与实际制空状态不同。',
      '戦闘開始時の搭載数推移': '战斗开始时的搭载数变化',
      '行クリックで詳細計算画面展開': '点击行展开详细计算画面',
      '出撃x回分の計算結果が表示されています。': '显示出击{number}次的计算结果。',
      '再計算': '重新计算',
      '再計算して精度を上げる': '重新计算以提高精度',
      '出撃後': '出击后',
      '全滅率': '全灭率',
      '制空': '制空',
      '制空状態': '制空状态',
      '消費予測': '消耗预测',
      '各フェーズ制空状態の確率': '各阶段制空状态概率',
      '基地x y波目': '基地{number} {wave}波',
      '本隊': '本队',
      '敵機残数': '敌方飞机残数',
      'このマスで選択する味方艦隊の陣形': '在此格选择我方舰队阵型',
      '敵艦': '敌方舰船',
      '初期搭載': '初始搭载',
      '残数平均': '残数平均',
      '棒立ち率': '棒立率',
      '詳細': '详情',
      '支援艦隊': '支援舰队',
      '艦隊': '舰队',
      '種別': '类型',
      '制空値は航空支援専用の制空値です。熟練度や改修値に影響されません。': '制空值是航空支援专用的制空值。不受熟练度和改修值影响。',
      '敵制空値は本隊航空戦終了時点での制空値の平均です。': '敌方制空值是本队航空战结束时的制空值平均值。',
      '詳細計算': '详细计算',
      '支援射撃': '支援射击',
      '航空支援': '航空支援',
      '対潜支援哨戒': '对潜支援哨戒',
      '対潜支援制空': '对潜支援制空',
      '支援長距離雷撃': '支援长距离雷击',
      '支援不可(要駆逐2)': '无法支援(需要2艘驱逐舰)',
      '支援不可(攻撃機なし)': '无法支援(无攻击机)',
      '不発': '未发动',
      '合計触接率': '总触接率',
      '対敵通常艦隊': '对敌方通常舰队',
      '対敵連合艦隊': '对敌方联合舰队',
      '触接開始率': '触接开始率',
      '触接率': '触接率',
      'x12触接': '×1.2触接',
      'x117触接': '×1.17触接',
      'x112触接': '×1.12触接',
      '触接不発': '触接未发动',
      '攻撃機選択': '选择攻击机',
      '搭載数': '搭载数',
      'クリティカル': '暴击',
      '姫級表示': '显示姬级',
      '対潜火力(確率)': '对潜火力(概率)',
      '航空支援火力': '航空支援火力',
      '倍率x': '倍率 x{number}',
      '対潜支援火力計算機で確認してください': '请在对潜支援火力计算器中确认',
      '雷装補正': '雷装补正',
      '種別倍率': '类型倍率',
      'CI倍率': 'CI倍率',
      '種別倍率(最小)': '类型倍率(最小)',
      '改修強化値': '改修强化值',
      '装備シナジーボーナス': '装备协同加成',
      '熟練甲板要員ボーナス': '熟练甲板人员加成',
      '実雷装値': '实际雷装值',
      '実爆装値': '实际爆装值',
      '実対潜値': '实际对潜值',
      '航空戦定数': '航空战常数',
      '基本攻撃力': '基本攻击力',
      'キャップ前攻撃力': '上限前攻击力',
      'キャップ後攻撃力': '上限后攻击力',
      'B-25補正': 'B-25补正',
      '基地航空隊補正': '基地航空队补正',
      '触接補正': '触接补正',
      '陸攻補正': '陆攻补正',
      '陸偵補正': '陆侦补正',
      '敵連合補正': '敌方联合补正',
      '特殊敵補正': '特殊敌方补正',
      '最終攻撃力': '最终攻击力',
      '最終攻撃力(最小)': '最终攻击力(最小)',
      '弾薬補正値': '弹药补正',
      'ダメージ幅': '伤害范围',
      '撃沈率': '击沉率',
      '大破率': '大破率',
      '中破率': '中破率',
      '確殺': '确杀',
      '残機数詳細': '残机数详情',
      '火力計算': '火力计算',
      '残機数分布': '残机数分布',
      '確率分布': '概率分布 [%]',
      '累積確率': '累积概率 [%]',
      '残機数': '残机数',
      '残機数分布をコピー': '复制残机数分布',
      '航空戦火力計算機': '航空战火力计算器',
      '残機数分布を利用': '使用残机数分布',
      '対空砲火により撃墜される機数の確率分布を利用して計算します。': '使用对空炮火击坠机数的概率分布进行计算。',
      '搭載数を固定してダメージを確認したい場合はチェックを外してください。': '如果要固定搭载数确认伤害，请取消勾选。',
      '残弾薬': '剩余弹药',
      '燃料補正': '燃料补正',
      '残弾薬補正': '弹药补正',
      '回避項x': '回避项 -{value}',
      '特効': '特效',
      'キャップ後火力に適用される倍率です。': '这是应用于上限后火力的倍率。',
      'をクリックすると特効値をリセットします。': '点击将重置特效值。',
      'クリティカル発生時のダメージを表示します。': '显示暴击发生时的伤害。',
      'クリティカル補正': '暴击补正',
      '熟練度クリティカル補正': '熟练度暴击补正',
      '連合': '联合',
      '防御側が連合艦隊であるかどうかを設定します。': '设置防御方是否为联合舰队。',
      'ダメージ計算結果': '伤害计算结果',
      '防御艦隊': '防御舰队',
      'x戦目': '第{number}战',
      '対潜攻撃不可': '无法进行对潜攻击',
      '割合ダメージ': '比例',
      '-': '-',
      '二式陸偵': '二式陆侦',
      '二式陸偵(熟練)': '二式陆侦(熟练)',
      '素火力': '素火力',
      '夜襲CI': '夜袭CI',
      '対空CI一覧': '对空CI列表',
      '種別id': '类型',
      '固定': '固定',
      '変動': '变动',
      '発動率': '发动率',
      '合計発動率': '总发动率',
      '基地': '基地',
    },
    EnemyEdit: {
      '敵艦編集': '编辑敌方舰船',
      '本機能は計算結果に大きな影響を及ぼすため、理解できる方のみ利用してください。': '此功能会对计算结果产生重大影响，请仅由理解其原理的人使用。',
      '指定した敵艦の装備や搭載数を自由に変更できます。': '可以自由更改指定敌方舰船的装备和搭载数。',
      '設定内容はお使いのブラウザでのみ有効で、各種共有機能等による共有は行いません。': '设置内容仅对您的浏览器有效，不会通过各种共享功能进行共享。',
      '編集する敵艦を選択': '选择要编辑的敌方舰船',
      '変更済み敵艦一覧': '已更改敌方舰船列表',
      '装備、搭載数を設定してください。': '请设置装备和搭载数。',
    },
    ItemList: {
      '図鑑id 名称検索': '图鉴ID 名称搜索',
      '敵装備': '敌方装备',
      '対地攻撃': '对地攻击',
      '夜間機': '夜间机',
      '射撃回避': '射击回避',
      '特効装備': '特效装备',
      '一列': '一列',
      '複数列': '多列',
      '以上': '以上',
      '以下': '以下',
      '所持装備反映': '反映持有装备',
      '改修値無効': '改修值无效',
      '装備シナジー無効': '装备协同无效',
      '熟練度成長': '熟练度成长',
      '戦': '战',
      '装備プリセット': '装备预设',
      '現在の装備構成で新規登録': '使用当前装备构成新建',
      '現在の装備構成で上書き': '使用当前装备构成覆盖',
      '名称': '名称',
      '補強増設': '补强增设',
      '固有プリセット': '固有预设',
      'プリセット': '预设',
      '保存しました。': '已保存。',
      '削除しました。': '已删除。',
      '在庫がなくても展開': '即使没有库存也展开',
      'x機': '{number}架',
      'ブラックリスト': '黑名单',
      'ブラックリスト登録済み装備': '仅黑名单已注册装备',
      'ブラックリストに登録された装備は、装備一覧画面にて表示されなくなります。': '黑名单中的装备将不会在装备列表画面中显示。',
      '全解除': '解除所有装备的黑名单状态',
      '射程増加': '射程增加',
      '改修値変更': '改修值更改',
      '装備名コピー': '复制装备名称',
      'wikiを開く': '打开wiki',
      'メニューを閉じる': '关闭菜单',
      '装備比較': '装备比较',
      '装備シナジー確認': '装备协同确认',
      '装備選択時は常に表示する': '选择装备时始终显示',
      '一括配備': '批量部署',
      '選択済': '已选择',
      '補': '补',
    },
    Database: {
      '在籍艦娘 / 所持装備データ読込中': '正在加载在籍舰娘/持有装备数据',
      '反映': '反映',
      '反映(改)': '反映(改)',
      '一覧': '列表',
      '札管理': '标记管理',
      '比較': '比较',
      '経験値': '经验值',
      '分析': '分析',
      'ステータス上昇': '状态提升',
      '基本条件': '基本条件',
      '名称検索': '名称搜索',
      '空白区切りで複数指定可': '可用空格分隔指定多个 (例:春雨 大鯨)',
      'ネタバレ防止': '防止剧透',
      '未着任艦非表示': '不显示未到任舰船',
      '未着任艦のみ': '仅未到任舰船',
      '補強増設開放済': '已开放补强增设',
      '海色リボン': '海色丝带',
      '白たすき': '白带',
      'Lv上限': '等级上限',
      'Lv下限': '等级下限',
      '取込Lv下限': '导入等级下限',
      '運上限': '运上限',
      '運下限': '运下限',
      '対潜上限': '对潜上限',
      '対潜下限': '对潜下限',
      '索敵上限': '索敌上限',
      '索敵下限': '索敌下限',
      '回避上限': '回避上限',
      '回避下限': '回避下限',
      '命中項上限': '命中项上限',
      '命中項下限': '命中项下限',
      'CI項上限': 'CI项上限',
      'CI項下限': 'CI项下限',
      '耐久上限': '耐久上限',
      '耐久下限': '耐久下限',
      '火力上限': '火力上限',
      '火力下限': '火力下限',
      '雷装上限': '雷装上限',
      '雷装下限': '雷装下限',
      '夜戦火力上限': '夜战火力上限',
      '夜戦火力下限': '夜战火力下限',
      '耐久改修': '耐久改修',
      '耐久改修2': '耐久改修',
      '対潜改修': '对潜改修',
      '対潜改修上限': '对潜改修上限',
      '対潜改修下限': '对潜改修下限',
      '運改修': '运改修',
      '運改修上限': '运改修上限',
      '運改修下限': '运改修下限',
      '艦種': '舰种',
      '国籍': '国籍',
      '日本': '日本',
      'アメリカ': '美国',
      'イタリア': '意大利',
      'イギリス': '英国',
      'ドイツ': '德国',
      'フランス': '法国',
      'ソ連': '苏联',
      'その他': '其他',
      'お札': '标记',
      '札なし': '无标记',
      '一括チェック': '批量勾选',
      '全選択': '全选',
      '一覧表示': '列表显示',
      '艦隊分析表示': '舰队分析显示',
      '未着任': '未到任',
      '在籍': '在籍',
      '新規登録': '新注册',
      '練度(Lv)': '等级',
      '着任': '到任',
      '除籍': '除籍',
      '本当に除籍しますか？': '确定要除籍吗？',
      'やっぱやめとく': '还是算了',
      '集計対象Lv': '统计对象等级',
      '合計艦娘数': '总舰娘数[艘]',
      'ケッコン艦': '婚舰[艘]',
      '運改修合計': '运改修合计',
      'まるゆ指数': 'まるゆ指数',
      'まるゆを近代化改修に使えば使うほど上昇します。': '使用まるゆ进行近代化改修越多，此指数越高。',
      'ケッコン以外の手段で運改修を進めていると上昇する指標です。': '这是通过非婚舰方式提升运改修时会上升的指标。',
      '耐久改修合計': '耐久改修合计',
      '対潜改修合計': '对潜改修合计',
      '補強増設艦': '补强增设舰[艘]',
      '改装設計図必要数': '改装设计图所需数量',
      '戦闘詳報必要数': '战斗详报所需数量',
      'カタパルト必要数': '弹射器所需数量',
      '改装設計図消費数': '改装设计图消耗数量',
      '戦闘詳報消費数': '战斗详报消耗数量',
      'カタパルト消費数': '弹射器消耗数量',
      '改装設計図': '改装设计图',
      '戦闘詳報': '战斗详报',
      'カタパルト': '弹射器',
      '残exp': '剩余经验值',
      '全て展開': '全部展开',
      '全て折りたたむ': '全部折叠',
      '隻数': '艘数',
      '最大Lv': '最大等级',
      '最小Lv': '最小等级',
      '中央Lv': '中央等级',
      '平均Lv': '平均等级',
      '総経験値': '总经验值',
      '1隻平均': '每艘平均',
      '経験値割合': '经验值比例',
      '艦種別Lv帯分析': '舰种等级带分析',
      'Lv帯別艦娘数': '等级带舰娘数',
      '艦娘数': '舰娘数 [艘]',
      '艦娘別経験値ランキング': '舰娘经验值排名',
      '登録艦隊': '注册舰队',
      '現在閲覧中の艦隊': '当前查看的舰队',
      '差': '差',
      'お札一括更新': '批量更新标记',
      'お札一斉解除': '同时解除所有标记',
      '解除': '解除',
      '札を解除します。よろしいですか？': '确定要解除标记吗？',
      '解散': '解散',
      '解散します。よろしいですか？': '确定要解散吗？',
      '未所持装備非表示': '不显示未持有装备',
      '改修下限': '改修下限',
      '改修上限': '改修上限',
      'カテゴリ': '类别',
      '総所持数表示': '显示总持有数',
      '図鑑ID': '图鉴ID',
      '所持数': '持有数',
      '破棄': '废弃',
      '全破棄': '全部废弃',
      '計算したい項目': '要计算的項目',
      '選択した項目と、次にその項目が1繰り上がるのは何Lvであるかを表示します。': '显示所选項目以及该項目下一次提升1点所需的等级。',
      '成長限界に到達した艦娘を省略': '省略已达到成长上限的舰娘',
      '任意': '任意',
      '任意表示列': '任意显示列',
      '必要経験値表示': '显示所需经验值',
      '運改修モード': '运改修模式',
      'Lvはそのままに、運の改修によってステータスを上昇させようとした場合の結果を計算します。': '计算在保持等级不变的情况下，通过运改修提升状态的结果。',
      '反映エリア': '反映区域',
      '共有URL発行機能': '分享URL生成功能',
      '共有URL作成': '创建分享URL',
      'URL発行': '生成URL',
      '自分の艦隊、装備情報を他の人に見てもらうためのURLを発行します。': '生成用于向他人展示您的舰队、装备信息的URL。',
      '発行された情報は閲覧専用です。発行されたURLを他人に公開しても、自分の艦娘や装備情報が書き換えられてしまうことはありません。': '生成的信息仅供查看。即使将生成的URL公开给他人，您的舰娘和装备信息也不会被修改。',
      '閲覧する側は、共有された艦娘や装備情報を元に編成を作成することができます。': '查看者可以根据共享的舰娘和装备信息创建编组。',
      'URL発行履歴': 'URL生成历史',
      '発行日': '生成日期',
      '展開': '展开',
      '他サイト連携': '其他网站联动',
      '艦隊分析コード': '舰队分析代码',
      '艦隊分析コードが出力されています。この文字列を別の端末で反映することで、艦隊情報を復元することができます。': '已输出舰队分析代码。通过在另一终端反映此字符串可以恢复舰队信息。',
      '艦隊コード': '舰队代码',
      '装備コード': '装备代码',
      '艦隊晒しページ(仮)で展開する場合はこちらから': '要在舰队展示页面(临时)展开，请点击这里',
      '反映手順を表示': '显示反映步骤',
      '反映手順を隠す': '隐藏反映步骤',
      '手順1': '登录后，在游戏开始画面右键点击，从上下文菜单中选择"检查"或"使用开发者工具检查"。',
      '手順2': '打开"网络"标签，确认红框部分，然后点击游戏开始。',
      '手順3': '显示母港画面后，会出现"port"项目，右键点击→"复制"→"复制响应"。',
      '手順4': '将复制的内容粘贴到下面的反映区域，然后点击"反映"。',
      '手順5': '将进行装备反映。会出现"require_info"项目，右键点击→"复制"→"复制响应"。',
      '下記はGoogle Chromeの場合です。': '以下为Google Chrome的情况。',
      '注意事項': '绝对不要双击或"在新标签页中打开""重新发送"等。',
      'ブラウザによって一部表記が変わります。': '显示可能因浏览器而异。',
      '未ロックの艦娘も含める': '包含未锁定的舰娘',
      'ロック済みの艦娘のみ': '仅已锁定的舰娘',
      '未ロックの装備も含める': '包含未锁定的装备',
      'ロック済みの装備のみ': '仅已锁定的装备',
      '札上書き注意': '当前注册的舰队与要导入的舰队的标记数据不一致。',
      'このまま取り込むと': '如果直接导入，',
      '札データを上書きして取り込む': '覆盖标记数据并导入',
      '札データを上書きせず取り込む': '不覆盖标记数据导入',
      '成長の記録': '成长记录',
      '表示': '显示',
      '新規': '到任',
      '更新': '更新',
      '経験値表示モード': '经验值显示模式',
      '着任しました。': '已到任。',
      '除籍されました。': '已除籍。',
      'xから改造されました。': '从{base}改造而来。',
      '補強増設を使用しました。': '使用了补强增设。',
      '上限Lvに達しました。': '已达到上限等级。',
      'ケッコンカッコカリしました。': '已进行婚舰。',
      'おめでとうございます！': '恭喜！',
      'Lv99までの折り返し地点を超えました。': '已超过距离Lv99的中点。',
      'LvoldからLvcurrentまでの折り返し地点を超えました。': '已超过从Lv{old}到Lv{current}的中点。',
      '後半戦もガンバレ！！！！': '后半段也加油！！！！',
      'Lvが上昇しました。': '等级提升了。',
      '第xスロットの搭載数をy機拡張しました！': '第{slot}槽搭载数扩展了{count}架！',
      'xしました。': '{x}了。',
      '増加経験値合計': '增加经验值合计 ',
      '統計': '统计',
      'さらに見る': '查看更多',
      '在籍率': '在籍率',
      '総在籍数': '总在籍数',
      '平均在籍数': '平均在籍数',
      '最多在籍数': '最多在籍数',
      '最多EXP': '最多经验值',
      'ケッコン率': '婚舰率',
      '補強増設開放率': '补强增设开放率',
      '補強増設開放数': '补强增设开放数',
      '海色リボン付与数': '海色丝带授予数',
      '白たすき付与数': '白带授予数',
      '総運改修値': '总运改修值',
      '総耐久改修値': '总耐久改修值',
      '総対潜改修値': '总对潜改修值',
      'Lv平均': '等级平均',
      'Lv標準偏差': '等级标准差',
      'Lv偏差値計算': '等级偏差值计算',
      '艦娘偏差値': '舰娘等级偏差值',
      '全体統計データ': '整体统计数据',
      'その他のデータ': '其他数据',
      '自分のデータと比較': '与自己的数据比较',
      'あなたのデータ': '您的数据',
      '総経験値平均': '总经验值平均',
      '総経験値中央値': '总经验值中位数',
      '標準偏差': '标准差',
      '偏差値': '偏差值',
      'コンバート艦': '转换舰 哪种形态最受欢迎？',
      '所持率': '持有率',
      '総在庫数': '总库存数',
      '平均所持数': '平均持有数',
      '最多所持数': '最多持有数',
      '集計の結果を閲覧する': '查看统计结果',
      '自分のデータを送信する': '发送舰队数据',
      'データ送信': '数据发送',
      'あなたの艦隊、装備データを統計データの集計対象として送信します。': '发送数据后，您的舰队、装备数据将成为统计的汇总对象。',
      '集計は一日一回実行されます。データを送信した後すぐに反映はされませんのでご注意ください。': '汇总每天凌晨4点左右执行。发送数据后不会立即反映，请注意。',
      '送信しました': '数据发送完成。请明天再来查看。',
      '集計データが取得できませんでした。': '无法获取汇总数据。',
      '一度、サイトの再読み込みをしてみてください。それでも取得できない場合は集計中かも。': '请尝试重新加载网站。如果仍然无法获取，可能正在汇总中，请稍后再试。',
      'Lv中央値': '等级中位数',
      'サーバー平均': '服务器平均',
      'サーバー中央値': '服务器中位数',
    },
    Extra: {
      '艦娘性能一覧': '舰娘性能列表',
      '艦娘の基本ステータスの確認と比較を行えます。': '可以确认和比较舰娘的基本状态。',
      '差分表示': '显示差异',
      '装備性能一覧': '装备性能列表',
      '搭載可能な装備で絞り込み': '按可搭载装备筛选',
      '対空射撃回避機体一覧': '对空射击回避机体列表',
      '装備の基本ステータスの確認と比較を行えます。': '可以确认和比较装备的基本状态。',
      '対潜値計算機': '对潜值计算器',
      '艦娘と装備から、指定した対潜値と必要なLvを計算します。': '根据舰娘和装备计算指定的对潜值和所需等级。',
      '素対潜': '素对潜',
      '初期対潜': '初始对潜',
      '最大対潜': '最大对潜',
      '表示対潜': '显示对潜',
      '装備対潜合計': '装备对潜合计',
      '装備ボーナス合計': '装备加成合计',
      '目標対潜値': '目标对潜值',
      '必要Exp': '所需经验值',
      '到達不可': '无法达到',
      '参考': '参考',
      '先制対潜発動条件について': '关于先制对潜发动条件',
      '敵艦生息地検索': '敌方舰船栖息地搜索',
      '指定した敵艦が登場する海域を検索します。データが更新されていない場合もあるので、あくまで参考程度に。': '搜索指定敌方舰船出现的海域。由于数据可能未更新，仅供参考。',
      '検索する敵艦を選択': '选择要搜索的敌方舰船',
      '艦隊詳細': '舰队详情',
      '戦果砲管理': '战果炮管理',
      '戦果に関係する任務の進捗を管理する機能です。': '这是管理与战果相关任务进度的功能。',
      '未達成': '未达成',
      '達成済': '已达成',
      '達成': '达成',
      '未達成にする': '设为未达成',
      'あと': '还剩',
      'x日': '{days}天',
      '1日': '1天',
      '失効': '失效',
      '達成日': '达成日期',
      'S勝利': 'S胜利',
      'A勝利': 'A胜利',
      '戦果砲残弾合計': '战果炮剩余弹药合计',
      'クォータリー': '季度',
      'イヤーリー': '年度',
      '単発': '单发',
      'マンスリー': '月度',
      'ウィークリー': '周度',
      '全て': '全部',
      'wikiで開く': '在wiki中打开',
      '改装特務空母「Gambier Bay Mk II」抜錨！': '改装特务航母「Gambier Bay Mk.II」起锚！',
      '戦果拡張任務！「Z作戦」前段作戦': '战果扩展任务！「Z作战」前段作战',
      '新編成「三川艦隊」、鉄底海峡に突入せよ！': '新编组「三川舰队」，突入铁底海峡！',
      '泊地周辺海域の安全確保を徹底せよ！': '彻底确保泊地周边海域安全！',
      '戦果拡張任務！「Z作戦」後段作戦': '战果扩展任务！「Z作战」后段作战',
      '南西諸島方面「海上警備行動」発令！': '西南诸岛方面「海上警备行动」发布！',
      '発令！「西方海域作戦」': '发布！「西方海域作战」',
      '拡張「六水戦」、最前線へ！': '扩展「六水战」，前往最前线！',
      'AL作戦': 'AL作战',
      '機動部隊決戦': '机动部队决战',
      'この任務を達成状態にしますか？': '要将此任务设为达成状态吗？',
      '達成した任務は、達成済タブに表示されるようになります。': '达成的任务将显示在"已达成"标签页中。',
      '達成しました。': '已达成。',
      '全ての任務進捗をリセットします。よろしいですか？': '将重置所有任务进度。确定吗？',
      'リセットしました。': '已重置。',
      '敵対空おばけ': '敌方对空怪物',
      '敵艦の対空砲火ランキングです。見かけたら気を付けるか覚悟しましょう。': '这是敌方舰船的对空炮火排名。遇到时要小心或做好觉悟。',
      '順位': '排名',
      '機': '架',
      '備考': '备注',
      '対空CI発動可能': '可发动对空CI',
      '装備シナジーチェッカー': '装备协同检查器(临时)',
      '条件': '条件',
      '累積可': '可累积',
      '累積不可': '不可累积',
      '水上電探': '水上电探',
      '対空電探': '对空电探',
      '命中電探': '命中+8以上的电探',
    },
    EType: {
      '小口径主砲': '小口径主炮',
      '中口径主砲': '中口径主炮',
      '大口径主砲': '大口径主炮',
      '副砲': '副炮',
      '魚雷': '鱼雷',
      '艦上戦闘機': '舰上战斗机',
      '艦上爆撃機': '舰上轰炸机',
      '艦上攻撃機': '舰上攻击机',
      '艦上偵察機': '舰上侦察机',
      '水上偵察機': '水上侦察机',
      '水上爆撃機': '水上轰炸机',
      '小型電探': '小型电探',
      '大型電探': '大型电探',
      'ソナー': '声纳',
      '爆雷': '深水炸弹',
      '爆雷投射機': '深水炸弹投射器',
      '追加装甲': '追加装甲',
      '機関部強化': '机关部强化',
      '対空強化弾': '对空强化弹',
      '対艦強化弾': '对舰强化弹',
      'VT信管': 'VT引信',
      '対空機銃': '对空机枪',
      '特殊潜航艇': '特殊潜航艇',
      '応急修理要員': '应急修理人员',
      '上陸用舟艇': '登陆用舟艇',
      '回転翼機': '旋翼机',
      '対潜哨戒機': '对潜哨戒机',
      '追加装甲(中型)': '追加装甲(中型)',
      '追加装甲(大型)': '追加装甲(大型)',
      '探照灯': '探照灯',
      '簡易輸送部材': '简易运输部件',
      '艦艇修理施設': '舰艇修理设施',
      '潜水艦魚雷': '潜艇鱼雷',
      '照明弾': '照明弹',
      '司令部施設': '司令部设施',
      '航空要員': '航空人员',
      '高射装置': '高射装置',
      '対地装備': '对地装备',
      '大口径主砲(II)': '大口径主炮(II)',
      '水上艦要員': '水面舰艇人员',
      '大型ソナー': '大型声纳',
      '大型飛行艇': '大型飞行艇',
      '大型探照灯': '大型探照灯',
      '戦闘糧食': '战斗口粮',
      '補給物資': '补给物资',
      '水上戦闘機': '水上战斗机',
      '特型内火艇': '特型内火艇',
      '陸上攻撃機': '陆上攻击机',
      '局地/陸軍戦闘機': '局地/陆军战斗机',
      '陸上偵察機': '陆上侦察机',
      '輸送機材': '运输器材',
      '潜水艦装備': '潜艇装备',
      '大型陸上機': '大型陆上机',
      '噴式戦闘機': '喷式战斗机',
      '噴式戦闘爆撃機': '喷式战斗轰炸机',
      '噴式艦上戦闘機': '喷式舰上战斗机',
      '噴式攻撃機': '喷式攻击机',
      '噴式偵察機': '喷式侦察机',
      '大型電探(II)': '大型电探(II)',
      '艦上偵察機(II)': '舰上侦察机(II)',
      '副砲(II)': '副炮(II)',
      '艦戦': '舰战',
      '艦爆': '舰爆',
      '艦攻': '舰攻',
      '艦偵': '舰侦',
      '噴式機': '喷式机',
      '水偵': '水侦',
      '水爆': '水爆',
      '水戦': '水战',
      '電探': '电探',
      '対潜装備': '对潜装备',
      '機銃': '机枪',
      '陸攻': '陆攻',
      '局戦': '局战',
      '陸偵': '陆侦',
      '陸戦部隊': '陆战部队',
      '艦載発煙装置': '舰载发烟装置',
      'その他': '其他',
    },
    SType: {
      '海防': '海防',
      '駆逐': '驱逐',
      '軽巡': '轻巡',
      '雷巡': '雷巡',
      '重巡': '重巡',
      '航巡': '航巡',
      '軽母': '轻母',
      '高戦': '高战',
      '戦巡': '战巡',
      '戦艦': '战舰',
      '航戦': '航战',
      '空母': '空母',
      '超戦': '超战',
      '潜水': '潜水',
      '航潜': '航潜',
      '輸送': '运输',
      '水母': '水母',
      '揚陸': '扬陆',
      '装母': '装母',
      '装空': '装空',
      '工作': '工作',
      '潜母': '潜母',
      '練巡': '练巡',
      '補給': '补给',
      '護母': '护母',
      'その他': '其他',
      '正規空母': '正规空母',
      '軽空母': '轻空母',
      '戦艦級': '战舰级',
      '重巡級': '重巡级',
      '軽巡級': '轻巡级',
      '駆逐艦': '驱逐舰',
      '海防艦': '海防舰',
      '潜水艦': '潜艇',
      '補助艦艇': '辅助舰艇',
      '合計': '合计',
      '高速戦艦': '高速战舰',
      '航空戦艦': '航空战舰',
      '潜水空母': '潜水空母',
      '揚陸艦': '扬陆舰',
      '装甲空母': '装甲空母',
      '工作艦': '工作舰',
      '潜水母艦': '潜水母舰',
      '巡洋艦系': '巡洋舰系',
      '軽空母と空母': '轻空母+空母',
      '護衛空母': '护卫空母',
      '駆逐艦または海防艦': '驱逐舰或海防舰',
      '軽巡または練巡': '轻巡或练巡',
    },
  },
};
